import Vue from 'vue'
import Router from 'vue-router'
import activityRoute from './activity'
import gzhRoute from './gongzhonghao'
import fission from './fission'
import conversion from './conversion'
import my from './my'
import appRoute from './app'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/experience',
      name: 'experience',
      component: resolve =>
        require(['@/pages/activity/experience/index'], resolve)
    },
    {
      path: '/landing',
      name: 'landing',
      component: resolve => require(['@/pages/landing/index'], resolve)
    },
    {
      path: '/multiSku',
      name: 'multiSku',
      component: resolve => require(['@/pages/landing/multiSku'], resolve)
    },
    {
      path: '/kol/landing',
      name: 'kol',
      component: resolve => require(['@/pages/landing/kol/index'], resolve)
    },
    {
      path: '/landing/order',
      name: 'landingOrder',
      component: resolve => require(['@/pages/landing/order'], resolve)
    },
    {
      path: '/landing/success',
      name: 'landingSuccess',
      component: resolve => require(['@/pages/landing/success'], resolve),
      meta: {
        title: '有道天天读'
      }
    },
    {
      path: '/landing/success-coupon',
      name: 'landingSuccessCoupon',
      component: resolve => require(['@/pages/landing/success-coupon'], resolve)
    },
    {
      path: '/landing/success-vip',
      name: 'landingSuccessVip',
      component: resolve => require(['@/pages/landing/success-vip'], resolve),
      meta: {
        title: '有道天天读'
      }
    },
    {
      path: '/landing/check',
      name: 'landingcheck',
      component: resolve => require(['@/pages/landing/buy-check'], resolve)
    },
    {
      path: '/landing/check-ireading',
      name: 'landingcheckIreading',
      component: resolve =>
        require(['@/pages/landing/buy-check-ireading'], resolve)
    },
    {
      path: '/landing/address',
      name: 'landingAddress',
      component: resolve => require(['@/pages/landing/address'], resolve)
    },
    {
      path: '/landing/schedule',
      name: 'landingSchedule',
      component: resolve => require(['@/pages/landing/schedule'], resolve)
    },
    {
      path: '/threeclass',
      name: 'threeclass',
      component: resolve =>
        require(['@/pages/activity/experience/index'], resolve)
    },
    {
      path: '/en-course6',
      name: 'en-course6',
      component: resolve =>
        require(['@/pages/activity/experience/index'], resolve)
    },
    {
      path: '/en-course7',
      name: 'en-course7',
      component: resolve =>
        require(['@/pages/activity/experience/index'], resolve)
    },
    {
      path: '/en-course8',
      name: 'en-course8',
      component: resolve =>
        require(['@/pages/activity/experience/index'], resolve)
    },
    {
      path: '/report',
      name: 'report',
      component: resolve => require(['@/pages/report'], resolve)
    },
    {
      path: '/lesson-report',
      name: 'lesson-report',
      component: resolve => require(['@/pages/lesson-report-new'], resolve)
    },
    {
      path: '/lesson-reportSet',
      name: 'lesson-reportSet',
      component: resolve => require(['@/pages/lesson-reportSet'], resolve)
    },
    {
      path: '/compareReport',
      name: 'compareReport',
      component: resolve => require(['@/pages/compareReport'], resolve)
    },
    {
      path: '/report-share',
      name: 'report-share',
      component: resolve => require(['@/pages/reportShare'], resolve)
    },
    {
      path: '/order',
      name: 'order',
      component: resolve => require(['@/pages/order'], resolve)
    },
    {
      path: '/lesson',
      name: 'lesson',
      component: resolve => require(['@/pages/lesson'], resolve)
    },
    {
      path: '/offical',
      name: 'offical',
      component: resolve => require(['@/pages/offical'], resolve)
    },
    {
      path: '/buysuccess',
      name: 'buysuccess',
      component: resolve => require(['@/pages/success'], resolve)
    },
    {
      path: '/buycheck1',
      name: 'buycheck1',
      component: resolve => require(['@/pages/buy-check1'], resolve)
    },
    {
      path: '/fail',
      name: 'fail',
      component: resolve => require(['@/pages/fail'], resolve)
    },
    {
      path: '/add',
      name: 'add',
      component: resolve => require(['@/pages/add'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve =>
        require(['@/pages/activity/freechannel/login.vue'], resolve)
    },
    {
      path: '/login1',
      name: 'login1',
      component: resolve => require(['@/components/login.vue'], resolve)
    },
    {
      path: '/address-experience',
      name: 'addressExperience',
      component: resolve =>
        require([
          '@/pages/activity/experience/components/addAddress.vue'
        ], resolve)
    },
    {
      path: '/mobilelogin',
      component: resolve =>
        require(['@/pages/activity/freechannel/login.vue'], resolve)
    },
    {
      path: '/accountquery',
      name: 'accountquery',
      component: resolve => require(['@/pages/login/query.vue'], resolve)
    },
    {
      path: '/accountBind',
      name: 'accountBind',
      component: resolve => require(['@/pages/login/accountBind.vue'], resolve)
    },
    {
      path: '/ke-bind',
      name: 'ke-bind',
      component: resolve => require(['@/pages/keBind.vue'], resolve)
    },
    {
      path: '/orderInfo',
      name: 'orderInfo',
      component: resolve => require(['@/pages/orderinfo.vue'], resolve)
    },
    {
      path: '/redeem',
      name: 'redeem',
      component: resolve => require(['@/pages/redeem/index.vue'], resolve)
    },
    {
      path: '/redeem/ireading',
      name: 'redeem',
      component: resolve =>
        require(['@/pages/redeem/ireadingRedeem.vue'], resolve),
      meta: {
        title: '有道天天读'
      }
    },
    {
      path: '/redeemsuccess',
      name: 'redeemsuccess',
      component: resolve =>
        require(['@/pages/redeem/redeemsuccess.vue'], resolve)
    },
    {
      path: '/download',
      name: 'download',
      component: resolve => require(['@/pages/download.vue'], resolve)
    },
    {
      path: '/shareReport',
      name: 'shareReport',
      component: resolve => require(['@/pages/reportShare/index.vue'], resolve)
    },
    {
      path: '/globalOffline',
      name: 'globalOffline',
      component: resolve => require(['@/components/OffLine.vue'], resolve)
    },
    ...activityRoute,
    ...gzhRoute,
    ...my,
    ...fission,
    ...appRoute,
    ...conversion,
    {
      path: '*',
      redirect: '/experience'
    }
  ]
})
router.beforeResolve((to, from, next) => {
  next()
  // DATracker.track_pageview()
})
export default router
